<template>
  <div class="batch-card-show-details">
    <div
      v-if="!isDetailsMode"
      :id="'batch-card-show-' + index"
      class="batch-card-show-details__icon"
    >
      <p
        :id="'batch-card-show-details-icon-' + index"
        class="icon-container show"
        @click="pushToBatchDetails()"
      >
        <svg-loader src="/static/images/icon-show-details.svg" />
        <md-tooltip
          md-delay="100"
          md-direction="top"
        >
          Mostrar amostras
        </md-tooltip>
      </p>
    </div>
    <div
      v-else
      class="batch-card-show-details__icon"
    >
      <p
        class="icon-container hide"
        @click="pushToBatchesList()"
      >
        <svg-loader src="/static/images/icon-hide-details.svg" />
        <md-tooltip
          md-delay="100"
          md-direction="top"
        >
          Voltar para listagem de lotes
        </md-tooltip>
      </p>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BatchCardShowDetails',
  props: {
    isDetailsMode: {
      type: Boolean
    },
    id: {
      type: [ String, Number ]
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['batchesCurrentTab']),
    ...mapGetters(['profile'])
  },
  methods: {
    pushToBatchDetails () {
      this.$router.push(
        {
          path: '/print-tag/batches/' + this.id,
          query: {
            startDate: this.$route.query.startDate,
            endDate: this.$route.query.endDate,
            packagingType: this.$route.query.packagingType,
            tab: this.batchesCurrentTab
          }
        }
      )
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Impressão de Etiquetas - Lote ' + this.batchesCurrentTab,
        'action': 'Visualizar detalhes do lote',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    pushToBatchesList () {
      this.$router.push({path: '/print-tag/batches/', query: { startDate: this.$route.query.startDate, endDate: this.$route.query.endDate, packagingType: this.$route.query.packagingType }})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../static/stylesheets/variables";

.batch-card-show-details {
  &__icon {
    display: flex;
    height: 30px;

    .hide {
      .md-icon {
        width: 30px;
        height: 28px;
        padding: 5px 5px 5px 0;
        margin-top: 0.1em;
        > svg {
          path {
            fill: $brand-primary;
            transition: 0.5s;
          }
        }
      }
    }

    .show {
      .md-icon {
        width: 20px;
        height: 20px;
        min-width: 23px;
        margin-top: 0.1em;
      }
    }

    .icon-container {
      cursor: pointer;
      height: 45px;

      &:hover,
      &:focus {
        .md-icon > svg {
          path {
            fill: $brand-primary;
            transition: 0.5s;
          }
        }
      }
    }
  }
}
</style>
